export default __webpack_public_path__ + "static/media/1(1).b709b2ed.jpg";